import React from "react";

import {
    CardTitle,
    Table,

} from "reactstrap";
import CustomTd from './CustomTd';
import Format from '../../common/Format';
import FormatCode from '../../common/FormatCode';
import Request from '../../common/Request';
import InputRadio from "../FormParts/InputRadio";
import {
    cst_customer_agreement_status,
  } from '../../variables/codes_map';

export default class ApprovedInfo extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            rootData: this.props.rootData,
            validateCallback: this.props.validateCallback,
            employeeType: this.props.employeeType,
            isEdit: this.props.isEdit != undefined ? this.props.isEdit : false,
            // 営業部承認
            sales_department_agreement_user: '',
            sales_department_agreement_picture: '',
            // 管理部承認
            management_department_agreement_user: '',
            management_department_agreement_picture: '',
            // 支店長承認
            branch_manager_agreement_user: '',
            branch_manager_agreement_picture: '',
            visible: this.props.visible !== undefined ? this.props.visible : true
        };

        this.checkNotApprovalAuth = this.checkNotApprovalAuth.bind(this)
    }

    componentDidUpdate(prevProps) {
        if (JSON.stringify(this.props) === JSON.stringify(prevProps))
            return;

        this.setState({
            rootData: this.props.rootData,
            validateCallback: this.props.validateCallback,
            employeeType: this.props.employeeType,
            visible: this.props.visible !== undefined ? this.props.visible : true
        });

        const lastUpdateUrl = '/api/landmark/lastupdate/' ;
        const params = {};
        if(this.props.rootData.values.sales_department_user_id != undefined) {
          Request.get(lastUpdateUrl + this.props.rootData.values.sales_department_user_id, params, res => {
            this.setState({
                sales_department_agreement_picture : res.Data.picture,
                sales_department_agreement_user : res.Data.name
            });
          });
        }
        if(this.props.rootData.values.management_department_user_id != undefined) {
          Request.get(lastUpdateUrl + this.props.rootData.values.management_department_user_id, params, res => {
            this.setState({
                management_department_agreement_picture : res.Data.picture,
                management_department_agreement_user : res.Data.name
             });
          });
        }
        if(this.props.rootData.values.branch_manager_user_id != undefined) {
          Request.get(lastUpdateUrl + this.props.rootData.values.branch_manager_user_id, params, res => {
            this.setState({
                branch_manager_agreement_picture : res.Data.picture,
                branch_manager_agreement_user : res.Data.name
            });
          });
        }
    }

    // 承認情報の権限がないものはtrue
    checkNotApprovalAuth(employeeType){
        switch(employeeType){
            case 1: // 特権管理権限：特権管理者
            case 2: // 業務部：支店長
            case 5: // 管理者
            case 9: // 営業部管理者
                return false;
            default:
                return true;
        }
    }

    render() {
        return (
            <>
                {this.state.visible && (() => {
                    return (
                        <>
                            <CardTitle tag="h4">承認情報</CardTitle>
                            <Table>
                                <tbody className="text-left">
                                    <tr>
                                        <td className="subTitle">営業部承認</td>
                                        <td>
                                            {this.state.isEdit ?
                                                <InputRadio
                                                    name='CUSTOMER__sales_department_agreement_flag'
                                                    options={cst_customer_agreement_status}
                                                    validateCallback={this.state.validateCallback}
                                                    copy={false}
                                                    rootData={this.state.rootData}
                                                    validateType='regist'
                                                    disabled={this.checkNotApprovalAuth(this.state.employeeType)}
                                                />
                                                :
                                                FormatCode.decode("cst_customer_agreement_status", this.state.rootData.values.sales_department_agreement_flag)
                                            }
                                        </td>
                                        <td className="subTitle">営業部承認者</td>
                                        <td >
                                            <div className="photo">
                                                {this.state.sales_department_agreement_user && <img alt="..." src={this.state.branch_manager_agreement_picture} />}
                                            </div>{this.state.sales_department_agreement_user}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="subTitle">管理部承認</td>
                                        <td>
                                            {this.state.isEdit ?
                                                <InputRadio
                                                    name='CUSTOMER__management_department_agreement_flag'
                                                    options={cst_customer_agreement_status}
                                                    validateCallback={this.state.validateCallback}
                                                    copy={false}
                                                    rootData={this.state.rootData}
                                                    validateType='regist'
                                                    disabled={this.checkNotApprovalAuth(this.state.employeeType)}
                                                />
                                                :
                                                FormatCode.decode("cst_customer_agreement_status", this.state.rootData.values.management_department_agreement_flag)
                                            }
                                        </td>
                                        <td className="subTitle">管理部承認者</td>
                                        <td >
                                            <div className="photo">
                                                {this.state.management_department_agreement_user && <img alt="..." src={this.state.management_department_agreement_picture} />}
                                            </div>{this.state.management_department_agreement_user}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="subTitle">オフィスL承認</td>
                                        <td>
                                            {this.state.isEdit ?
                                                <InputRadio
                                                    name='CUSTOMER__branch_manager_agreement_flag'
                                                    options={cst_customer_agreement_status}
                                                    validateCallback={this.state.validateCallback}
                                                    copy={false}
                                                    rootData={this.state.rootData}
                                                    validateType='regist'
                                                    disabled={this.checkNotApprovalAuth(this.state.employeeType)}
                                                 />
                                                :
                                                FormatCode.decode("cst_customer_agreement_status", this.state.rootData.values.branch_manager_agreement_flag)
                                            }
                                        </td>
                                        <td className="subTitle">オフィスL承認者</td>
                                        <td >
                                            <div className="photo">
                                                {this.state.branch_manager_agreement_user && <img alt="..." src={this.state.branch_manager_agreement_picture} />}
                                            </div>{this.state.branch_manager_agreement_user}
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>
                        </>
                    )
                })()}
            </>
        );
    }

 
}
